import React, { useRef } from 'react';
import ReactDOM from 'react-dom';
import * as PropTypes from 'prop-types';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { useAdvancedSearch } from '../hooks/useAdvancedSearch';
import {
    useQueryParams,
    StringParam,
    withDefault,
    encodeQueryParams,
} from 'use-query-params';
import { stringify } from 'query-string';
import { ArrayOfObjectsParam } from '../hooks/utils';
import { useCookies } from 'react-cookie';
import { v4 as uuidv4 } from 'uuid';
import { AND, ANY, CONTAINS } from '../views/AdvancedSearch/SearchConstants';
import { FormRowTemplate } from '../views/AdvancedSearch/FormRowTemplate';

const target = document.getElementById('basicSearchPortal');
const SEARCH_PATH = '/search/:view';

// The regular expression that extract asset type machine name from path
export const at_regex =
    /\/(audio-video|thematic-collections|collections|images|places|bibliographies|sources|subjects|terms|modern-texts|texts|visuals)/;

export function BasicSearch(props) {
    const history = useHistory();
    const inputEl = useRef(null);
    const advSearchState = useAdvancedSearch();
    const [cookies, setCookie] = useCookies();
    const eid = props?.eid || 'sui-search';
    let searchview = cookies['searchview'];
    if (!searchview || searchview.length == 0) {
        searchview = process.env?.REACT_APP_SEARCH_VIEW_DEFAULT || 'list';
        setCookie('searchview', searchview);
    }
    // ?filters=id.asset_type%3Aaudio-video__lb.audio-video__op.AND

    // This tells us whether we are viewing the search results
    // so that we can give a link to go there (or not).
    const searchView = useRouteMatch(SEARCH_PATH);

    const [query, setQuery] = useQueryParams({
        searchText: StringParam,
        filters: withDefault(ArrayOfObjectsParam, []),
    });
    let { searchText: search, filters } = query;
    // path_filter is a boolean setting in Mandala Plugin (wp_kmaps). If on, need to filter searches from content type in the path
    if (window?.mandala_wp?.path_filter) {
        const path = window.location.pathname;
        const mtch = path.match(at_regex);
        if (mtch) {
            const filter_asset = mtch[1]
                .replace('thematic-', '')
                .replace('modern-', '')
                .replace('bibliographies', 'sources');
            if (!advSearchState.isRemoved('asset_type', filter_asset)) {
                filters = [
                    {
                        id: `asset_type:${filter_asset}`,
                        field: 'asset_type',
                        match: filter_asset,
                        label: filter_asset,
                        operator: 'AND',
                    },
                ];
            }
        }
    }

    const handleSubmit = () => {
        document.getElementById('advanced-search-tree-toggle').click();
        const inputNoQuotes = inputEl?.current?.value
            ? inputEl.current.value.trim()
            : '';
        // console.log("input no quotes", `'${inputNoQuotes}'`);
        const row = new FormRowTemplate(1, AND, ANY, CONTAINS, inputNoQuotes);
        advSearchState.updateRows([row]);

        if (!searchView) {
            const encodedQuery = encodeQueryParams(
                {
                    searchText: StringParam,
                    filters: withDefault(ArrayOfObjectsParam, []),
                },
                {
                    searchText: inputNoQuotes,
                    filters: [...filters],
                }
            );
            if (process.env.REACT_APP_STANDALONE === 'standalone') {
                window.location.hash = `#/search/${searchview}?${stringify(
                    encodedQuery
                )}`;
            } else {
                //history.push('/search/deck');
                history.push({
                    pathname: `/search/` + searchview,
                    search: `?${stringify(encodedQuery)}`,
                });
            }
        } else {
            setQuery(
                {
                    searchText: inputNoQuotes,
                    filters: [...filters],
                },
                'push'
            );
        }
    };
    const clearInput = () => {
        inputEl.current.value = '';
        setQuery(
            {
                searchText: '',
                filters,
            },
            'push'
        );
    };
    const handleKey = (x) => {
        // submit on return
        if (x.keyCode === 13) {
            handleSubmit();
        }
    };

    function cleanSearch(srch) {
        let newSearch = '';
        if (!srch.startsWith('advSearch')) {
            newSearch = srch;
        }
        return newSearch;
    }
    // console.log("search in basic search", search);

    const searchVal = decodeURIComponent(
        cleanSearch(encodeURIComponent(search || ''))
    );

    const basicSearchPortal = (
        <>
            <div className="sui-search1">
                <input
                    key={search}
                    type="text"
                    id={eid}
                    className="sui-search2"
                    autoFocus
                    defaultValue={searchVal}
                    placeholder="Search &amp; Explore!"
                    onKeyDownCapture={handleKey}
                    ref={inputEl}
                />

                <span
                    id="sui-clear"
                    className="sui-search3"
                    onClick={clearInput}
                >
                    {' '}
                </span>
                <span
                    id="sui-searchgo"
                    className="sui-search4"
                    onClick={handleSubmit}
                >
                    <span className={'icon shanticon-magnify'}></span>
                </span>
            </div>
        </>
    );

    if (target) {
        return ReactDOM.createPortal(basicSearchPortal, target);
    } else {
        return basicSearchPortal;
    }
}

BasicSearch.propTypes = { onChange: PropTypes.func };
